
import { AppMap } from "../api/model/AppMap"

const freshMap : AppMap = {
    Home : false,
    division : false,
    settings : false,
    support : false,
    rewards : false,
    pretrip : false,
    currentload : false,
    loadhistory : false,
    loadhistoryloadnum : false,
    preplanned : false,
    trailertracking : false,
    photoupload : false,
    traileridphotos : false,
    deferments : false,
    loadselection : false,
    personaladvance : false,
    payroll : false,
    payrollfaq : false,
    paychecks : false,
    paycheckscheckDate : false,
    paycheckscheckDateCA : false,
    leasepurchase : false,
    referral : false,
    inbox : false,
    cabinphoto : false,
    safety : false,
    permits : false,
    benefits : false,
    safetyvideos : false,
    safetydocuments : false,
    safetycontacts : false,
    maintenancevids : false,
    servicelocations : false,
    helpdesk : false,
    chainofcommand : false,
    passenger : false,
    helpdirect : false,
    contacts : false,
    load : false,
    trip : false,
    money : false,
    docs : false,
    registervehicle : false,
    contracts : false,
    safetybonusdetails : false,
    safetybonus : false,
}
    export default freshMap